import React from 'react'
import { DocumentPrivacy } from '@trustero/trustero-api-web/lib/trust/trust_pb'
import { PRIVACY_LEVEL_LABELS } from 'src/pages/TrustAccessManagement/visitoranalytics/VisitorAnalytics.constants'
import { FilterName, FilterParam } from '../../../../FilterBar.types'
import { FilterDropdown } from '../../../FilterDropdown'

export const DashboardTPAccessLevelFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const filterValues =
    Object.values(DocumentPrivacy).map((privacyLevel) => ({
      label: PRIVACY_LEVEL_LABELS[privacyLevel as DocumentPrivacy],
      value: privacyLevel.toString(),
    })) || []

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_TP_ACCESS_LEVEL_DIMENSION}
      filterName={FilterName.DASHBOARD_TP_ACCESS_LEVEL_DIMENSION}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
